import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useFormContext, FormProvider } from 'react-hook-form';
import { WsSelect, WsSelectObj, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface ISpreadSheetProps {
  candidatesData?: Map<any, any>;
}

const UploadSpreadSheetsColumns = ({ candidatesData = new Map() }: ISpreadSheetProps) => {
  const formData = useFormContext();

  const columnOptions: WsSelectObj[] = [
    {
      label: 'Select',
      value: '',
    },
    {
      label: 'Alternate Emails',
      value: 'alternateEmails',
    },
    {
      label: 'Candidate Headline',
      value: 'candidateHeadline',
    },
    {
      label: 'Candidate Summary',
      value: 'candidateSummary',
    },
    {
      label: 'Curr. Company Name',
      value: 'companyName',
    },
    {
      label: 'Current Job Title',
      value: 'currentJobTitle',
    },
    {
      label: 'Current Location',
      value: 'currentLocation',
    },
    {
      label: 'Current Salary',
      value: 'currentSalary',
    },
    {
      label: 'Expected Salary',
      value: 'expectedCompensation',
    },
    {
      label: 'Date Of Birth',
      value: 'dateOfBirth',
    },
    {
      label: 'Doctorate degree',
      value: 'docDegree',
    },
    {
      label: 'Doctorate graduation year',
      value: 'docGraduationYear',
    },
    {
      label: 'Doctorate specialization',
      value: 'docSpecialisation',
    },
    {
      label: 'Doctorate university/institute name',
      value: 'docUniversity',
    },
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Gender',
      value: 'gender',
    },
    {
      label: 'Industry',
      value: 'industry',
    },
    {
      label: 'LinkedIn Profile Link',
      value: 'linkedInURL',
    },
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Notice Period',
      value: 'noticePeriod',
    },
    {
      label: 'PG graduation year',
      value: 'pgGraduationYear',
    },
    {
      label: 'PG specialization',
      value: 'pgSpecialisation',
    },
    {
      label: 'PG university/institute name',
      value: 'pgUniversity',
    },
    {
      label: 'Post graduation degree',
      value: 'pgDegree',
    },
    {
      label: 'Phone Number',
      value: 'phoneNumber',
    },
    {
      label: 'Preferred Locations',
      value: 'preferredLocations',
    },
    {
      label: 'Relocation Preference',
      value: 'relocationPreference',
    },
    {
      label: 'Role',
      value: 'role',
    },
    {
      label: 'Skills',
      value: 'skills',
    },
    {
      label: 'Source',
      value: 'source',
    },
    {
      label: 'Summary',
      value: 'summary',
    },
    {
      label: 'Tags',
      value: 'tags',
    },
    {
      label: 'Total Experience',
      value: 'totalExperience',
    },
    {
      label: 'UG Graduation Year',
      value: 'ugGraduationYear',
    },
    {
      label: 'UG specialization',
      value: 'ugSpecialisation',
    },
    {
      label: 'UG university/institute name',
      value: 'ugUniversity',
    },
    {
      label: 'UG Degree',
      value: 'ugDegree',
    },
    {
      label: 'Visa Type',
      value: 'visaType',
    },
    {
      label: 'Marital Status',
      value: 'maritalStatus',
    },
    {
      label: 'Date of Application',
      value: 'appliedOn',
    },
    {
      label: 'Candidate ID',
      value: 'candidateID',
    },
  ];

  const rows = createRows(candidatesData);

  return (
    <FormProvider {...formData}>
      <Box component="form">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, minHeight: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {rows &&
                  rows.length > 0 &&
                  rows
                    ?.find((value) => value)
                    ?.map((row, index) => (
                      <TableCell key={index}>
                        <Box minWidth={130}>
                          <WsSelect
                            name={`fieldMappings[${index}]`}
                            label={''}
                            defaultValue=""
                            selectArray={columnOptions}
                            size="small"
                          />
                        </Box>
                      </TableCell>
                    ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row &&
                    row.map((rowData, index) => (
                      <TableCell key={index} padding="none" align="center">
                        <WsTypography
                          color={WsTypoColors.BLACK}
                          bold={rowIndex === 0}
                          variant={WsTypoVariants.BODY2}
                        >
                          {rowData}
                        </WsTypography>
                      </TableCell>
                    ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </FormProvider>
  );
};

export default UploadSpreadSheetsColumns;

const createRows = (candidatesData: Map<any, any>) => {
  const rows: string[][] = [];
  for (let i = 0; i < 99; i++) {
    const row = candidatesData[i];
    rows.push(row);
  }
  return rows;
};
